import { writable } from 'svelte/store';

export const taskSearchStore = writable('');
